import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { getTranslation } from "../services/translations";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./BookAppointment.css";

const BookAppointment = () => {
  const { language } = useLanguage();
  const t = k => getTranslation(language, k);

  return (
    <div className="bk-page nb-page-offset">
      <Navbar />

      {/* Hero */}
      <section className="bk-hero">
        <div className="bk-hero-overlay" />
        <div className="bk-hero-content">
          <div className="bk-hero-eyebrow">{t("appointmentsEyebrow")}</div>
          <h1 className="bk-hero-title">{t("bookAnAppointment")}</h1>
          <p className="bk-hero-subtitle">{t("bookSubtitle")}</p>
          <div className="bk-hero-breadcrumb">
            <Link to="/" className="bk-breadcrumb-link">{t("home")}</Link>
            <span className="bk-breadcrumb-sep">›</span>
            <span>{t("bookAnAppointment")}</span>
          </div>
        </div>
      </section>

      {/* Single Call Card */}
      <section className="bk-options-section">
        <div className="bk-single-inner">
          <div className="bk-option-card bk-call-card bk-card-centered">
            <div className="bk-option-icon bk-call-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="36" height="36">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
              </svg>
            </div>
            <div className="bk-option-badge bk-badge-instant">{t("instantBadge")}</div>
            <h2 className="bk-option-title">{t("callNowTitle")}</h2>
            <p className="bk-option-desc">{t("callNowDesc")}</p>
            <div className="bk-option-details">
              <div className="bk-detail-row">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="15" height="15"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                <span>{t("monSatHours")}</span>
              </div>
              <div className="bk-detail-row">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="15" height="15"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                <span>{t("emergency247")}</span>
              </div>
            </div>
            <a href="tel:+919996504991" className="bk-option-btn bk-btn-call">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
              </svg>
              {t("callNumber")}
            </a>
          </div>
        </div>
      </section>

      {/* Info strip */}
      <section className="bk-info-strip">
        <div className="bk-info-inner">
          <div className="bk-info-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="#0077b6" strokeWidth="2" width="22" height="22"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            <div>
              <strong>{t("opdHours")}</strong>
              <span>{t("opdHoursDetail")}</span>
            </div>
          </div>
          <div className="bk-info-div"/>
          <div className="bk-info-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="#0077b6" strokeWidth="2" width="22" height="22"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            <div>
              <strong>{t("emergencyLabel")}</strong>
              <span>{t("emergency247Available")}</span>
            </div>
          </div>
          <div className="bk-info-div"/>
          <div className="bk-info-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="#0077b6" strokeWidth="2" width="22" height="22"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
            <div>
              <strong>{t("locationLabel")}</strong>
              <span>{t("narnaul")}</span>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default BookAppointment;
